// extracted by mini-css-extract-plugin
export var progressBar = "_g8-0";
export var progressBarInner = "_g8-1";